import events_01 from './JPEG/events_01.jpg';
import events_02 from './JPEG/events_02.jpg';
import events_03 from './JPEG/events_03.jpg';
import events_04 from './JPEG/events_04.jpg';
import events_05 from './JPEG/events_05.jpg';
import events_06 from './JPEG/events_06.jpg';
import events_07 from './JPEG/events_07.jpg';
import events_08 from './JPEG/events_08.jpg';
import events_09 from './JPEG/events_09.jpg';
import events_10 from './JPEG/events_10.jpg';
import events_11 from './JPEG/events_11.jpg';

const events = [
  events_01,
  events_02,
  events_03,
  events_04,
  events_05,
  events_06,
  events_07,
  events_08,
  events_09,
  events_10,
  events_11,
];

export default events;



// WEBPACK FOOTER //
// ./src/images/events/index.js